import { render, staticRenderFns } from "./orderDisplay.vue?vue&type=template&id=0bb7145e&scoped=true&"
import script from "./orderDisplay.vue?vue&type=script&lang=js&"
export * from "./orderDisplay.vue?vue&type=script&lang=js&"
import style0 from "./orderDisplay.vue?vue&type=style&index=0&id=0bb7145e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb7145e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bb7145e')) {
      api.createRecord('0bb7145e', component.options)
    } else {
      api.reload('0bb7145e', component.options)
    }
    module.hot.accept("./orderDisplay.vue?vue&type=template&id=0bb7145e&scoped=true&", function () {
      api.rerender('0bb7145e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/orderDisplay.vue"
export default component.exports